var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 594,
    height: 483,
    viewBox: "0 0 594 483",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_19840)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 594,
    height: 483,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133.984,
    y1: 323.829,
    x2: 30.9839,
    y2: 491.829,
    stroke: "#DADADA",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.338,
    y1: 323.053,
    x2: 165.338,
    y2: 491.053,
    stroke: "#DADADA",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 302.5,
    y1: 322.043,
    x2: 300.5,
    y2: 486.043,
    stroke: "#DADADA",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 389.385,
    y1: 321.109,
    x2: 434.385,
    y2: 492.109,
    stroke: "#DADADA",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 504.983,
    y1: 375.5,
    x2: 101.983,
    y2: 373.5,
    stroke: "#DADADA",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 541,
    y1: 434.5,
    x2: 68,
    y2: 434.5,
    stroke: "#DADADA",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 473.014,
    y1: 320.22,
    x2: 574.014,
    y2: 491.22,
    stroke: "#DADADA",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 36,
    width: 63,
    height: 18,
    rx: 9,
    fill: "#027CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377,
    y: 409,
    width: 93,
    height: 32,
    rx: 16,
    fill: "#027CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 193,
    width: 86,
    height: 20,
    rx: 10,
    transform: "rotate(-90 107 193)",
    fill: "#027CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476,
    y: 193,
    width: 86,
    height: 20,
    rx: 10,
    transform: "rotate(-90 476 193)",
    fill: "#027CFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_402_19840)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 127,
    y1: 119.5,
    x2: 489,
    y2: 119.5,
    stroke: "#6189AD",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_402_19840)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 362,
    y2: -1.5,
    transform: "matrix(-1 0 0 1 489 183)",
    stroke: "#6189AD",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_402_19840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.211 138.355C189.745 133.13 195.641 130 201.949 130H396.348C402.765 130 408.748 133.239 412.257 138.612L512.811 292.612C521.063 305.25 511.995 322 496.902 322H97.7888C82.556 322 73.5165 304.973 82.0506 292.355L186.211 138.355Z",
    fill: "#78ACD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.949 132H396.348C402.089 132 407.443 134.898 410.582 139.706L511.137 293.706C518.52 305.013 510.407 320 496.902 320H97.7888C84.1595 320 76.0715 304.765 83.7073 293.476L187.867 139.476C191.029 134.801 196.305 132 201.949 132Z",
    stroke: "#0B6A93",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("line", {
    x1: 213.662,
    y1: 142.112,
    x2: 110.662,
    y2: 296.112,
    stroke: "white",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.074 242.586C167.954 240.991 169.631 240 171.453 240H270.601C273.513 240 275.809 242.48 275.586 245.383L273.355 274.383C273.155 276.988 270.983 279 268.37 279H155.466C151.661 279 149.25 274.918 151.087 271.586L167.074 242.586Z",
    fill: "#044764"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.316 146.051C243.725 144.826 244.871 144 246.162 144H255.037C257.026 144 258.464 145.9 257.924 147.814L248.616 180.814C248.252 182.107 247.072 183 245.729 183H235.162C233.115 183 231.669 180.994 232.316 179.051L243.316 146.051Z",
    fill: "#066C92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.986 145.604C278.185 144.113 279.456 143 280.96 143H290.268C291.95 143 293.304 144.383 293.268 146.064L292.56 179.211C292.526 180.783 291.284 182.062 289.714 182.143L276.604 182.815C274.73 182.911 273.229 181.283 273.477 179.423L277.986 145.604Z",
    fill: "#066C92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.12 147.115C311.054 145.414 312.416 144 314.118 144H323.553C324.977 144 326.205 145.002 326.492 146.397L333.261 179.397C333.643 181.258 332.221 183 330.322 183H315.387C313.775 183 312.451 181.726 312.389 180.115L311.12 147.115Z",
    fill: "#066C92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.449 212.602C398.294 209.959 400.23 207 403.114 207H410.548C412.052 207 413.43 207.845 414.112 209.186L452.541 284.686C453.895 287.347 451.962 290.5 448.976 290.5H436.117C434.527 290.5 433.089 289.559 432.452 288.102L399.449 212.602Z",
    fill: "#00263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.981 143.641C370.043 141.442 371.656 139 374.046 139V139C375.311 139 376.467 139.716 377.03 140.849L392.127 171.22C393.448 173.879 391.514 177 388.545 177H387.864C386.262 177 384.814 176.044 384.185 174.57L370.981 143.641Z",
    fill: "#00263C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_402_19840",
    x: 115,
    y: 110,
    width: 386,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.537255 0 0 0 0 0.678431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_19840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_19840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_402_19840",
    x: 115,
    y: 162,
    width: 386,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.380392 0 0 0 0 0.537255 0 0 0 0 0.678431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_19840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_19840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_402_19840",
    x: 3.75659,
    y: 124,
    width: 587.177,
    height: 342,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 69
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_19840"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_19840",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_19840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 594,
    height: 483,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain);
export default __webpack_public_path__ + "static/media/main.0c69f05cfd198f470b98c5c711f16115.svg";
export { ForwardRef as ReactComponent };